// @flow
import type { Node } from 'react';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import Checkbox from '../../../../../elements/Checkbox/Checkbox';
import Loading from '../../../../../elements/Loading/Loading';
import ReportModalContainer from '../../../../report/container/ReportModalContainer';

import commonStyle from '../../../components/OrderCommon.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import formStyle from '../../../../../assets/styles/form.scss';
import style from './InTransit.scss';

import type { Order } from '../../../../../entities';
import type { Motive, MotiveKey } from '../../../../report/duck';
import type { LocaleState } from '../../../../locale/duck';

type Props = {
  +buildStatusBoard: () => Node;
  +buildProducts: () => Node;
  +buildSummary: () => Node;
  +buildTravelerInfo: () => Node;
  +postConfirmation: (orderId: string) => void;
  +order: Order;
  +isPostingConfirmation: boolean;
  +motives?: { [key: MotiveKey]: Motive[] };
  +locale: LocaleState;
};

type State = {
  confirm: boolean;
  reportModalVisible: boolean;
};

export default class InTransit extends Component<Props, State> {
  state = {
    confirm: false,
    reportModalVisible: false,
  };

  handleChange = () => {
    this.setState((prevState: State) => ({
      confirm: !prevState.confirm,
    }));
  };

  handleCloseReportModal = () => {
    this.setState({ reportModalVisible: false });
  };

  handleOpenReportModal = () => {
    this.setState({ reportModalVisible: true });
  };

  render() {
    const {
      buildStatusBoard, buildProducts, buildSummary, buildTravelerInfo, postConfirmation, order, isPostingConfirmation,
      motives, locale,
    } = this.props;
    const { confirm, reportModalVisible } = this.state;
    const { lastMileTracking } = order;
    const options = motives ? motives.purchaser.map((motive: Motive) => ({
      value: motive.name,
      label: motive.translations[locale.locale.toUpperCase()],
    })) : [];
    return (
      <Fragment>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            {buildStatusBoard()}
            <FormattedMessage id="order.purchase.inTransit.qempo.subtitle">{
              txt => <h2 className={commonStyle.title}>{txt}</h2>
            }</FormattedMessage>
            <section className={classNames(boxStyle.box, style.box)}>
              {isPostingConfirmation && <Loading className={style.loading}
                                                 type="circle"/>}
              <section className={classNames({ [style.disabled]: isPostingConfirmation })}>
                {/*<FormattedMessage id="order.purchase.inTransit.shipping.tracking.subtitle">{
                  txt => <h2 className={classNames(boxStyle.boxTitle)}>{txt}</h2>
                }</FormattedMessage>
                <form className={classNames(formStyle.formWrap, style.tracking)}>
                  <section className={classNames(formStyle.row, formStyle.dualWrap)}>
                    <article className={formStyle.col}>
                      <FormattedMessage id="order.purchase.inTransit.shipping.tracking.courier">{
                        txt => (<label className={formStyle.label}>{txt}</label>)
                      }</FormattedMessage>
                      <p>{lastMileTracking ? lastMileTracking.courier.name : ''}</p>
                    </article>
                    <article className={formStyle.col}>
                      <FormattedMessage id="order.purchase.inTransit.shipping.tracking.number">{
                        txt => (<label className={formStyle.label}>{txt}</label>)
                      }</FormattedMessage>
                      <p className={style.trackingNumber}>{lastMileTracking ? lastMileTracking.trackingNumber : ''}</p>
                    </article>
                  </section>
                </form>*/}
                <FormattedMessage id="order.purchase.inTransit.shipping.confirm.subtitle">{
                  txt => <h2 className={classNames(boxStyle.boxTitle)}>{txt}</h2>
                }</FormattedMessage>
                <FormattedMessage id="order.purchase.inTransit.shipping.confirm.option">{
                  txt => <Checkbox handleChange={this.handleChange}
                                   name="confirm"
                                   value="confirm"
                                   isChecked={confirm}>{txt}</Checkbox>
                }</FormattedMessage>
                <FormattedMessage id="order.purchase.inTransit.shipping.confirm.button">{
                  txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.confirm)}
                                 disabled={!confirm}
                                 onClick={() => postConfirmation(order.id)}>{txt}</button>
                }</FormattedMessage>
              </section>
            </section>
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildTravelerInfo()}
            {buildSummary()}
            <FormattedMessage id="order.purchase.inTransit.report.button">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.redInverse, style.report)}
                             onClick={this.handleOpenReportModal}>{txt}</button>
            }</FormattedMessage>
          </section>
        </main>
        <ReportModalContainer color="lightBlue"
                              reportType="PURCHASER_TRACKING"
                              isOpen={reportModalVisible}
                              handleClose={this.handleCloseReportModal}
                              isDiy={order.isDiy}
                              id={order.id}
                              options={options}
                              successIntl="modal.report.purchaser.success.text"/>
      </Fragment>
    );
  }
}

InTransit.propTypes = {
  buildStatusBoard: PropTypes.func.isRequired,
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
  buildTravelerInfo: PropTypes.func.isRequired,
  postConfirmation: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  isPostingConfirmation: PropTypes.bool,
  motives: PropTypes.object,
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/in-transit/components/InTransit.jsx